import { useState } from 'react';
import ServiceNavbar from '../services/shared/ServiceNavbar';
import Footer from '../home/components/Footer';

interface Review {
  id: number;
  name: string;
  location: string;
  initials: string;
  stars: number;
  text: string;
  service: string;
  serviceLabel: string;
  date: string;
  source: 'google' | 'facebook';
}

const reviews: Review[] = [
  {
    id: 1,
    name: 'Mark & Sandra T.',
    location: 'Portage, MI',
    initials: 'MT',
    stars: 5,
    text: 'DOC Electric did a full panel upgrade and installed our Tesla Wall Connector in the same visit. From quote to completion in under a week. They organized every wire in that panel like it was art. Won\'t use anyone else for electrical work — period.',
    service: 'ev-chargers',
    serviceLabel: 'EV Charger',
    date: 'March 2025',
    source: 'google',
  },
  {
    id: 2,
    name: 'James R.',
    location: 'Kalamazoo, MI',
    initials: 'JR',
    stars: 5,
    text: 'We used DOC Electric for the full electrical rough-in on our 3,500 sq ft new build. They coordinated with our general contractor, showed up every scheduled day, and passed every inspection on the first try. Communication was outstanding throughout.',
    service: 'new-construction',
    serviceLabel: 'New Construction',
    date: 'February 2025',
    source: 'google',
  },
  {
    id: 3,
    name: 'Rebecca L.',
    location: 'Mattawan, MI',
    initials: 'RL',
    stars: 5,
    text: 'After a scary situation with flickering lights and a warm outlet, DOC Electric came out the next morning. Diagnosed a failing main breaker, replaced it safely, and walked me through every step. Honest, calm, and genuinely caring about our family\'s safety.',
    service: 'residential',
    serviceLabel: 'Residential Repair',
    date: 'January 2025',
    source: 'google',
  },
  {
    id: 4,
    name: 'Chris & Amy W.',
    location: 'Plainwell, MI',
    initials: 'CW',
    stars: 5,
    text: 'The lighting transformation in our home is incredible. Every can light, every dimmer, every outdoor accent was placed perfectly. DOC Electric even helped us think through the lighting plan. The craftsmanship is unmatched — our home looks like a magazine photo.',
    service: 'lighting',
    serviceLabel: 'Specialty Lighting',
    date: 'March 2025',
    source: 'facebook',
  },
  {
    id: 5,
    name: 'David H.',
    location: 'Kalamazoo, MI',
    initials: 'DH',
    stars: 5,
    text: 'I manage 14 rental properties in the Kalamazoo area and DOC Electric handles all my electrical work. Fast turnaround, consistent quality, fair pricing, and they actually communicate. Finding reliable contractors is hard — these guys are the real deal.',
    service: 'residential',
    serviceLabel: 'Residential Repair',
    date: 'December 2024',
    source: 'google',
  },
  {
    id: 6,
    name: 'Tom & Carol B.',
    location: 'Portage, MI',
    initials: 'TB',
    stars: 5,
    text: 'We bought an older home that needed a full rewire. DOC Electric did an incredible job — minimal disruption, beautiful work inside the walls, and a spotless cleanup every day. Our new panel looks like a work of art. We couldn\'t be more impressed.',
    service: 'residential',
    serviceLabel: 'Residential Repair',
    date: 'November 2024',
    source: 'google',
  },
  {
    id: 7,
    name: 'Sarah K.',
    location: 'Battle Creek, MI',
    initials: 'SK',
    stars: 5,
    text: 'Hired DOC Electric to install a standby generator before last winter. They handled everything — permits, transfer switch, gas coordination. When the big ice storm hit in February, our house was the only one on the block with lights. Worth absolutely every penny.',
    service: 'generators',
    serviceLabel: 'Generator',
    date: 'October 2024',
    source: 'google',
  },
  {
    id: 8,
    name: 'Mike J.',
    location: 'Vicksburg, MI',
    initials: 'MJ',
    stars: 5,
    text: 'DOC Electric wired our new 8,000 sq ft commercial facility. Complex project with 3-phase power, dedicated circuits, and a lot of coordination. They were professional, thorough, and finished ahead of schedule. Our building inspector actually complimented the workmanship.',
    service: 'new-construction',
    serviceLabel: 'New Construction',
    date: 'September 2024',
    source: 'google',
  },
  {
    id: 9,
    name: 'Lisa M.',
    location: 'Otsego, MI',
    initials: 'LM',
    stars: 5,
    text: 'I got EV charger quotes from three companies. DOC Electric found that my panel needed a small upgrade first — something the other two missed or ignored. They fixed it, installed the Level 2 charger, and the total was still less than one competitor\'s quote. Honest and skilled.',
    service: 'ev-chargers',
    serviceLabel: 'EV Charger',
    date: 'August 2024',
    source: 'facebook',
  },
  {
    id: 10,
    name: 'Kevin R.',
    location: 'Kalamazoo, MI',
    initials: 'KR',
    stars: 5,
    text: 'Needed my panel upgraded to 200A and solar-ready before our solar installation. DOC Electric handled it cleanly — new panel, proper grounding, conduit run for the solar company. Everything was done ahead of schedule and passed inspection first try. Very impressed.',
    service: 'solar',
    serviceLabel: 'Solar & Panel',
    date: 'July 2024',
    source: 'google',
  },
  {
    id: 11,
    name: 'Jennifer H.',
    location: 'Mattawan, MI',
    initials: 'JH',
    stars: 5,
    text: 'Our backyard lighting is stunning — path lights, accent trees, and a gorgeous pergola setup. DOC Electric helped us design the layout, used quality fixtures, and the installation looks completely professional. The neighbors have already asked who did the work.',
    service: 'lighting',
    serviceLabel: 'Specialty Lighting',
    date: 'June 2024',
    source: 'google',
  },
  {
    id: 12,
    name: 'Robert S.',
    location: 'Portage, MI',
    initials: 'RS',
    stars: 5,
    text: 'Power outage Sunday night, called DOC Electric Monday morning. They had someone at my house by 10 AM, found a corroded service entrance cable, and had it fixed by early afternoon. Fair price, zero drama. That\'s exactly what you want in an emergency electrical situation.',
    service: 'residential',
    serviceLabel: 'Residential Repair',
    date: 'May 2024',
    source: 'google',
  },
  {
    id: 13,
    name: 'Amy & Daniel F.',
    location: 'Richland, MI',
    initials: 'AF',
    stars: 5,
    text: 'Kitchen renovation required moving a lot of circuits and adding dedicated appliance lines. DOC Electric worked around our contractor\'s schedule perfectly, no delays, and the work inside the walls was immaculate. We\'ll use them for every future project without question.',
    service: 'residential',
    serviceLabel: 'Residential Repair',
    date: 'April 2024',
    source: 'google',
  },
];

const filters = [
  { id: 'all', label: 'All Reviews' },
  { id: 'new-construction', label: 'New Construction' },
  { id: 'residential', label: 'Residential Repair' },
  { id: 'generators', label: 'Generators' },
  { id: 'ev-chargers', label: 'EV Chargers' },
  { id: 'solar', label: 'Solar & Panel' },
  { id: 'lighting', label: 'Lighting' },
];

const StarRow = ({ count }: { count: number }) => (
  <div className="flex items-center gap-0.5">
    {Array.from({ length: count }).map((_, i) => (
      <span key={i} className="w-4 h-4 flex items-center justify-center">
        <i className="ri-star-fill text-[#00D9FF] text-[14px]" />
      </span>
    ))}
  </div>
);

const ReviewCard = ({ review, delay }: { review: Review; delay: number }) => (
  <div
    className={`scroll-reveal scroll-delay-${Math.min(delay, 6)} group relative bg-cr rounded-2xl p-7 border border-[var(--bd)] hover:border-[#00D9FF]/30 hover:-translate-y-1.5 hover:shadow-[0_12px_40px_rgba(0,0,0,0.12)] transition-all duration-400 cursor-default overflow-hidden`}
  >
    {/* Top row: stars + service tag */}
    <div className="flex items-start justify-between gap-3 mb-4">
      <StarRow count={review.stars} />
      <span className="flex-shrink-0 px-2.5 py-1 bg-[#00D9FF]/10 border border-[#00D9FF]/20 rounded-full text-[#00D9FF] text-[10px] font-semibold tracking-wider whitespace-nowrap">
        {review.serviceLabel}
      </span>
    </div>

    {/* Review text */}
    <p className="text-[var(--ts)] text-[14px] leading-relaxed italic mb-5">
      &ldquo;{review.text}&rdquo;
    </p>

    {/* Attribution */}
    <div className="flex items-center justify-between gap-3 pt-4 border-t border-[var(--bd)]">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#0A1628] dark:bg-[#0A1628] text-white text-[12px] font-bold flex-shrink-0">
          {review.initials}
        </div>
        <div>
          <div className="text-[var(--tp)] text-[13px] font-bold">{review.name}</div>
          <div className="text-[var(--tm)] text-[11px]">{review.location}</div>
        </div>
      </div>

      <div className="flex items-center gap-2 flex-shrink-0">
        <span className="w-4 h-4 flex items-center justify-center">
          {review.source === 'google' ? (
            <i className="ri-google-fill text-[#DB4437] text-sm" />
          ) : (
            <i className="ri-facebook-fill text-[#1877F2] text-sm" />
          )}
        </span>
        <span className="text-[var(--tm)] text-[11px] whitespace-nowrap">{review.date}</span>
      </div>
    </div>
  </div>
);

const ReviewsPage = () => {
  const [activeFilter, setActiveFilter] = useState<string>('all');

  const filteredReviews =
    activeFilter === 'all' ? reviews : reviews.filter((r) => r.service === activeFilter);

  const ratingCounts = [5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5];
  const avgRating = (ratingCounts.reduce((a, b) => a + b, 0) / ratingCounts.length).toFixed(1);

  return (
    <div className="min-h-screen bg-pg font-sans">
      <ServiceNavbar />

      {/* ── Hero ─────────────────────────────────────── */}
      <section className="relative overflow-hidden" style={{ minHeight: '62vh' }}>
        <div className="absolute inset-0">
          <img
            src="https://public.readdy.ai/ai/img_res/99803c3232ebf87256521522da4529c3.jpg"
            alt="Happy clients of DOC Electric"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#060E1C]/95 via-[#0A1628]/85 to-[#060E1C]/60" />
          <div className="absolute inset-0 bg-gradient-to-b from-[#060E1C]/40 via-transparent to-[#0A1628]/90" />
        </div>
        <div className="absolute bottom-0 left-0 right-0 h-[1px] bg-gradient-to-r from-transparent via-[#00D9FF]/25 to-transparent" />

        <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10 pt-40 pb-20">
          <div className="flex items-center gap-3 mb-5">
            <span className="h-[1px] w-8 bg-[#00D9FF]" />
            <span className="text-[#00D9FF] text-[11px] font-bold tracking-[3px] uppercase">Client Reviews</span>
          </div>

          <h1 className="text-5xl md:text-6xl font-black text-white leading-tight tracking-tight mb-5 max-w-3xl">
            What Kalamazoo<br />
            <span className="text-[#00D9FF] [text-shadow:0_0_40px_rgba(0,217,255,0.4)]">Homeowners Are Saying.</span>
          </h1>
          <p className="text-white/75 text-lg max-w-xl leading-relaxed mb-10">
            Real experiences from real clients across southwest Michigan.
            We earn your trust one job at a time — and it shows.
          </p>

          {/* Stats row */}
          <div className="flex flex-wrap gap-6 sm:gap-10">
            {[
              { icon: 'ri-star-fill', value: `${avgRating} / 5.0`, label: 'Average Rating' },
              { icon: 'ri-chat-quote-fill', value: '200+', label: 'Verified Reviews' },
              { icon: 'ri-thumb-up-fill', value: '100%', label: 'Recommend Us' },
              { icon: 'ri-calendar-fill', value: '20+ Yrs', label: 'In Southwest MI' },
            ].map((stat) => (
              <div key={stat.label} className="flex items-center gap-3">
                <span className="w-9 h-9 flex items-center justify-center bg-[#00D9FF]/15 border border-[#00D9FF]/25 rounded-lg flex-shrink-0">
                  <i className={`${stat.icon} text-[#00D9FF] text-base`} />
                </span>
                <div>
                  <div className="text-white font-black text-[17px] leading-tight">{stat.value}</div>
                  <div className="text-white/55 text-[11px] font-medium">{stat.label}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Platform Trust Strip ──────────────────────── */}
      <section className="bg-cr border-b border-[var(--bd)] py-8">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="flex flex-wrap items-center justify-center gap-8 sm:gap-14">
            <div className="flex items-center gap-3">
              <span className="w-8 h-8 flex items-center justify-center">
                <i className="ri-google-fill text-[#DB4437] text-xl" />
              </span>
              <div>
                <div className="text-[var(--tp)] font-black text-[15px]">5.0 Stars</div>
                <div className="text-[var(--tm)] text-[11px] font-medium">Google Reviews</div>
              </div>
            </div>
            <div className="w-px h-8 bg-[var(--bd)] hidden sm:block" />
            <div className="flex items-center gap-3">
              <span className="w-8 h-8 flex items-center justify-center">
                <i className="ri-facebook-fill text-[#1877F2] text-xl" />
              </span>
              <div>
                <div className="text-[var(--tp)] font-black text-[15px]">Highly Recommended</div>
                <div className="text-[var(--tm)] text-[11px] font-medium">Facebook Reviews</div>
              </div>
            </div>
            <div className="w-px h-8 bg-[var(--bd)] hidden sm:block" />
            <div className="flex items-center gap-3">
              <span className="w-8 h-8 flex items-center justify-center">
                <i className="ri-verified-badge-fill text-[#00D9FF] text-xl" />
              </span>
              <div>
                <div className="text-[var(--tp)] font-black text-[15px]">Licensed &amp; Vetted</div>
                <div className="text-[var(--tm)] text-[11px] font-medium">Michigan Licensed Contractor</div>
              </div>
            </div>
            <div className="w-px h-8 bg-[var(--bd)] hidden sm:block" />
            <div className="flex items-center gap-3">
              <span className="w-8 h-8 flex items-center justify-center">
                <i className="ri-award-fill text-amber-400 text-xl" />
              </span>
              <div>
                <div className="text-[var(--tp)] font-black text-[15px]">Top Rated</div>
                <div className="text-[var(--tm)] text-[11px] font-medium">Southwest Michigan</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── Reviews Section ───────────────────────────── */}
      <section className="bg-sf py-20">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">

          {/* Section label + count */}
          <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-10 scroll-reveal">
            <div>
              <span className="inline-block text-[#00D9FF] text-[11px] font-bold tracking-[3px] uppercase mb-3">What They Said</span>
              <h2 className="text-3xl lg:text-4xl font-black text-[var(--tp)]">
                Verified Client Reviews
              </h2>
            </div>
            <p className="text-[var(--tm)] text-[14px]">
              Showing <strong className="text-[var(--tp)]">{filteredReviews.length}</strong> of {reviews.length} reviews
            </p>
          </div>

          {/* Filter tabs */}
          <div className="flex flex-wrap gap-2 mb-10 scroll-reveal scroll-delay-1">
            {filters.map((f) => (
              <button
                key={f.id}
                onClick={() => setActiveFilter(f.id)}
                className={`px-4 py-2 rounded-full text-[12px] font-semibold tracking-wide transition-all duration-200 cursor-pointer whitespace-nowrap border ${
                  activeFilter === f.id
                    ? 'bg-[#00D9FF] border-[#00D9FF] text-[#0A1628] shadow-[0_0_16px_rgba(0,217,255,0.3)]'
                    : 'bg-cr border-[var(--bd)] text-[var(--tm)] hover:border-[#00D9FF]/40 hover:text-[var(--tp)]'
                }`}
              >
                {f.label}
              </button>
            ))}
          </div>

          {/* Reviews grid */}
          {filteredReviews.length > 0 ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
              {filteredReviews.map((review, i) => (
                <ReviewCard key={review.id} review={review} delay={i + 1} />
              ))}
            </div>
          ) : (
            <div className="text-center py-16 text-[var(--tm)] text-[15px]">
              No reviews in this category yet. Check back soon!
            </div>
          )}
        </div>
      </section>

      {/* ── Featured Quote ────────────────────────────── */}
      <section className="bg-cr border-y border-[var(--bd)] py-16">
        <div className="max-w-4xl mx-auto px-6 lg:px-10 text-center scroll-reveal">
          <div className="w-12 h-12 flex items-center justify-center bg-[#00D9FF]/10 border border-[#00D9FF]/25 rounded-full mx-auto mb-6">
            <i className="ri-double-quotes-l text-[#00D9FF] text-xl" />
          </div>
          <p className="text-[var(--tp)] text-2xl lg:text-3xl font-black leading-snug italic mb-6 max-w-3xl mx-auto">
            &ldquo;I&apos;ve hired a lot of contractors over the years. DOC Electric is the first one I&apos;ve ever called back the same week just to say thank you. That says everything.&rdquo;
          </p>
          <div className="flex items-center justify-center gap-3">
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#0A1628] text-white text-[12px] font-bold">
              DH
            </div>
            <div className="text-left">
              <div className="text-[var(--tp)] text-[14px] font-bold">David H.</div>
              <div className="text-[var(--tm)] text-[12px]">Property Manager, Kalamazoo MI</div>
            </div>
            <span className="ml-2 w-5 h-5 flex items-center justify-center">
              <i className="ri-google-fill text-[#DB4437] text-lg" />
            </span>
          </div>
        </div>
      </section>

      {/* ── CTA ───────────────────────────────────────── */}
      <section className="relative bg-[#060E1C] py-20 overflow-hidden">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[400px] bg-[#00D9FF]/4 rounded-full blur-[100px] pointer-events-none" />
        <div className="absolute top-0 left-0 right-0 h-[1px] bg-gradient-to-r from-transparent via-[#00D9FF]/30 to-transparent" />

        <div className="relative z-10 max-w-2xl mx-auto px-6 text-center scroll-reveal">
          <span className="inline-block text-[#00D9FF] text-[11px] font-bold tracking-[3px] uppercase mb-5">Ready to Join Them?</span>
          <h2 className="text-4xl lg:text-5xl font-black text-white leading-tight mb-5">
            Let&apos;s Make Your<br />
            <span className="text-[#00D9FF] [text-shadow:0_0_32px_rgba(0,217,255,0.4)]">Project the Next Success Story.</span>
          </h2>
          <p className="text-white/70 text-[16px] leading-relaxed mb-8 max-w-lg mx-auto">
            Free estimates, clear communication, and the kind of quality work people write reviews about.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="/contact"
              className="inline-flex items-center gap-3 px-10 py-4 bg-[#00D9FF] hover:bg-[#00c5e8] text-[#0A1628] font-black text-[14px] uppercase tracking-wider rounded-xl transition-all duration-300 hover:shadow-[0_0_40px_rgba(0,217,255,0.5)] hover:-translate-y-0.5 cursor-pointer whitespace-nowrap"
            >
              Request a Free Estimate
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-arrow-right-line" />
              </span>
            </a>
            <a
              href="tel:+12693700765"
              className="inline-flex items-center gap-3 px-10 py-4 border-2 border-white/25 hover:border-white/50 text-white font-semibold text-[14px] rounded-xl transition-all duration-300 hover:bg-white/5 cursor-pointer whitespace-nowrap"
            >
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-phone-fill text-[#00D9FF]" />
              </span>
              (269) 370-0765
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ReviewsPage;
